import React from 'react';

import { Box } from '@chakra-ui/react';
import { PlainTextHeader } from 'Deer/components/HeaderComponents/PlainTextHeader';
import { MemoizedNavLevelPrivateRoutes } from 'Deer/components/RoutingComps/MemoizedNavLevelPrivateRoutes';
import { useRouteToNavLevels } from 'Deer/hooks/useRouteToL3';
import { LevelUpAnalyticsProvider } from 'screens/analytics/continuousFeedback/context/provider';
import { checkIntentLandingPagesFeatureEnabled } from 'utils/helpers/featureFlags';

import { PageTabbedNavigationV1 } from 'uiToolkitV1/PageTabbedNavigationV1';

const Develop = () => {
  const { l3Options: tabs } = useRouteToNavLevels();

  return (
    <>
      {!checkIntentLandingPagesFeatureEnabled() ? (
        <>
          <PlainTextHeader>My competencies</PlainTextHeader>
          <PageTabbedNavigationV1 tabs={tabs} />
          <Box my={1} />
        </>
      ) : null}
      <LevelUpAnalyticsProvider>
        <MemoizedNavLevelPrivateRoutes />
      </LevelUpAnalyticsProvider>
    </>
  );
};

export default Develop;
